import { render, staticRenderFns } from "./SolicitudInternaForm.vue?vue&type=template&id=027521ba"
import script from "./SolicitudInternaForm.vue?vue&type=script&lang=js"
export * from "./SolicitudInternaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports